import { ENV_VARS, Environments } from './env';

export enum ExternalService {
  Sentry = 'sentry',
  Clarity = 'clarity',
}

const ENABLED_ENVIRONMENTS: Record<ExternalService, readonly Environments[]> = {
  [ExternalService.Sentry]: [
    Environments.STAGING,
    Environments.SANDBOX,
    Environments.PRODUCTION,
  ],
  [ExternalService.Clarity]: [Environments.PRODUCTION],
};

export const isServiceEnabled = (
  service: ExternalService,
  environment: Environments = ENV_VARS.environment,
): boolean => ENABLED_ENVIRONMENTS[service].includes(environment);
